import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, FormControl, FormGroup, Row } from 'react-bootstrap'
import { FaUserTimes } from 'react-icons/fa'
import { IoCheckmarkSharp, IoFemale, IoLogOut, IoMale, IoMaleFemaleOutline } from 'react-icons/io5'
import { MdDateRange } from 'react-icons/md'
import { RiPencilFill } from 'react-icons/ri'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import userLogo from "../Images/userImage.png";

const UserAccount = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState("Siddhant Gautam");
    const [mobile, setMobile] = useState("7317675527");
    const [selectedDate, setSelectedDate] = useState(null);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);


    const handleEditClick = () => {
        setIsEditing(!isEditing);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setIsCalendarOpen(false);
    };


    return (
        <div>
            <Container fluid>
                <Row>
                    <Col md={12} style={{ paddingLeft: 25 }}>
                        <FormGroup className='mb-3'>
                            <Form.Label className="text_lightDark fs-30 fw-bold">My Account</Form.Label>
                        </FormGroup>
                        <div style={{ height: "calc(100vh - 140px" }} className="overflow-auto">
                            <div className="d-flex justify-content-center mb-5">
                                <Card className="p-1 bg-stell shadow-lg w-100">
                                    <Card.Body>
                                        <div className="d-flex text_lightDark">
                                            <img src={userLogo} alt='user-image' className="user-icon" />
                                            <div className="ms-3 pt-2">
                                                <p className='m-0 fw-bold fs-22'>Siddhant Gautam</p>
                                                <p>Not a Member Yet</p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='w-100 hstack justify-content-between mb-4'>
                                <span className="text_lightDark fs-22 fw-bold">Persional Details</span>
                                <Button variant="dark" onClick={handleEditClick}> <RiPencilFill className="mx-2" />{isEditing ? "Save Changes" : "Edit Profile"}</Button>
                            </div>
                            <div className="text_lightDark mb-3">
                                <span className="fs-16" style={{ letterSpacing: "0.15px" }}>UserName</span>

                            </div>
                            <Card className="bg-stell shadow-lg w-25 mb-4" style={{ padding: "11px 10px 9px" }}>
                                {isEditing ? (
                                    <FormControl
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="profileFormControl bg-dark  border-0 text-white p-2"
                                        autoFocus
                                    />
                                ) : (
                                    <span className="text_lightDark">{name}</span>
                                )}
                            </Card>
                            <div className="text_lightDark mb-3">
                                <span className="fs-16" style={{ letterSpacing: "0.15px" }}>Mobile No.</span>

                            </div>
                            <div className="d-flex gap-3 mb-4">
                                <Card className="bg-stell shadow-lg" style={{ padding: "11px 10px 9px" }}>
                                    <span className="text_lightDark">+91</span>
                                </Card>
                                <Card className="bg-stell shadow-lg w-25" style={{ padding: "11px 10px 9px" }}>
                                    {isEditing ? (
                                        <FormControl
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value)}
                                            className="profileFormControl bg-dark  border-0 text-white p-2"
                                            autoFocus
                                        />
                                    ) : (
                                        <span className="text_lightDark">{mobile}</span>
                                    )}
                                </Card>
                            </div>
                            <div className="text_lightDark mb-3">
                                <span className="fs-16" style={{ letterSpacing: "0.15px" }}>Date Of Birth</span>

                            </div>
                            <div className="mb-4">
                                <div className="d-flex gap-2">
                                    <Card className="bg-stell shadow-lg w-25" style={{ padding: "11px 10px 9px" }}>
                                        <span className="text_lightDark">
                                            {selectedDate ? selectedDate.toISOString().split("T")[0] : "Select Date"}
                                        </span>
                                    </Card>
                                    <Card
                                        className="bg-stell shadow p-2"
                                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                    >
                                        <MdDateRange className="text-white fs-22" />
                                    </Card>

                                </div>
                            </div>
                            <>
                                {isCalendarOpen && (
                                    <DatePicker
                                        selected={selectedDate}
                                        onChange={handleDateChange}
                                        inline
                                    />
                                )}
                            </>
                            <div className="text_lightDark mb-3">
                                <span className="fs-16" style={{ letterSpacing: "0.15px" }}>Gender</span>
                            </div>
                            <div className="d-flex gap-3 mb-4">
                                <div
                                    className="p-4 bg-stell shadow-lg border-dark rounded d-flex flex-column align-items-center position-relative"
                                    style={{ width: '150px', height: '150px' }}
                                >
                                    <div
                                        className="d-flex gendersymobol justify-content-center align-items-center"
                                    >
                                        <IoMale />
                                    </div>
                                    <div
                                        className="position-absolute genderCheckbox top-0 end-0 d-flex justify-content-center align-items-center"
                                    >
                                        <IoCheckmarkSharp />
                                    </div>
                                    <div className="pt-3 fw-bold text-white">
                                        Male
                                    </div>
                                </div>
                                <div
                                    className="p-4 bg-stell shadow-lg border-dark rounded d-flex flex-column align-items-center position-relative"
                                    style={{ width: '150px', height: '150px' }}
                                >
                                    <div
                                        className="d-flex gendersymobol justify-content-center align-items-center"
                                    >
                                        <IoFemale />
                                    </div>
                                    <div
                                        className="position-absolute genderCheckbox top-0 end-0 d-flex justify-content-center align-items-center"
                                    >
                                        <IoCheckmarkSharp />
                                    </div>
                                    <div className="pt-3 fw-bold text-white">
                                        Female
                                    </div>
                                </div>
                                <div
                                    className="p-4 bg-stell shadow-lg border-dark rounded d-flex flex-column align-items-center position-relative"
                                    style={{ width: '150px', height: '150px' }}
                                >
                                    <div
                                        className="d-flex gendersymobol justify-content-center align-items-center"
                                    >
                                        <IoMaleFemaleOutline />
                                    </div>
                                    <div
                                        className="position-absolute genderCheckbox top-0 end-0 d-flex justify-content-center align-items-center"
                                    >
                                        <IoCheckmarkSharp />
                                    </div>
                                    <div className="pt-3 fw-bold text-white">
                                        Other
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex gap-2 mb-3" style={{ cursor: "pointer" }}>
                                <FaUserTimes className="text_lightDark fs-22 fw-bold" />
                                <span className="text_lightDark ms-2">Delete Account</span>
                            </div>
                            <div className="d-flex gap-2" style={{ cursor: "pointer" }}>
                                <IoLogOut className="text_lightDark fs-22 fw-bold" />
                                <span className="text_lightDark ms-2">LogOut Of Galax OTT</span>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default UserAccount